import { useEffect } from 'react';
import { LoadingWrapper, ReactTable } from '../common';
import {
  MaintenanceStatistics,
  MaintenanceTableConfig,
  MaintenanceDashboardHeader,
  MaintenanceMessages,
  MaintenanceEmptyState
} from './components';
import { useAssetProblems } from './hooks';
import '../../css/MaintenanceDashboard.css';

export const MaintenanceDashboard = () => {
  const {
    assetProblems,
    permissions,
    loading,
    error,
    success,
    loadMaintenanceData,
    getStatistics,
    clearMessages
  } = useAssetProblems();

  useEffect(() => {
    // Load data with default filter for out of service or maintenance assets
    loadMaintenanceData({
      asset_status: 'out-of-service,maintenance' // Filter for assets needing maintenance
    });
  }, [loadMaintenanceData]);

  const statistics = getStatistics();
  const hasData = assetProblems.length > 0;

  return (
    <div className="maintenance-dashboard">
      <LoadingWrapper loading={loading} text="Loading asset problems">
        <div className="dashboard-header">
          <MaintenanceDashboardHeader />
        </div>

        <MaintenanceMessages
          error={error}
          success={success}
          onClearMessages={clearMessages}
        />

        {hasData && (
          <div className="statistics-section">
            <MaintenanceStatistics statistics={statistics} />
          </div>
        )}

        <div className="table-section">
          {hasData ? (
            <div className="mobile-friendly-table-div-wrapper">
              <div className="mobile-friendly-table-div">
                <ReactTable
                  className="channel-table"
                  data={assetProblems}
                  columns={MaintenanceTableConfig.getColumns(permissions)}
                  hiddenColumns={['id']}
                />
              </div>
            </div>
          ) : (
            <MaintenanceEmptyState loading={loading} />
          )}
        </div>
      </LoadingWrapper>
    </div>
  );
};

export default MaintenanceDashboard;
